import React, { useContext } from "react";
import {
   ECLLoader,
   ECLSelect,
   ECLThemeImage,
   ECLUserInfo,
} from "../../../index";
import { UserContext } from "../../../../utilities/contexts";
import "@github/markdown-toolbar-element";
import "./EditorToolbar.css";
import { translate } from "../../../../utilities/Translate";

export default function EditorToolbar(props) {
   const users = useContext(UserContext);
   if (!users) {
      return <ECLLoader />;
   }

   return (
      <markdown-toolbar for={props.editorId} class="github-markdown-toolbar">
         <md-header>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="heading"
               alt={translate("Heading Text")}
            />
         </md-header>
         <md-bold>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="bold"
               alt={translate("Bold text")}
            />
         </md-bold>
         <md-italic>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="italic"
               alt={translate("Italic text")}
            />
         </md-italic>
         <md-strikethrough>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="strikethrough"
               alt={translate("Strikethrough text")}
            />
         </md-strikethrough>
         <md-unordered-list>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="list"
               alt={translate("Unordered list")}
            />
         </md-unordered-list>
         <md-ordered-list>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="list-ol"
               alt={translate("Ordered list")}
            />
         </md-ordered-list>
         <md-task-list>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="list-check"
               alt={translate("Check list")}
            />
         </md-task-list>
         <md-quote>
            <ECLThemeImage
               className="rt-icon"
               fontAwesome="indent"
               alt={translate("Indent")}
            />
         </md-quote>
         <div className="ecl-markdown-button">
            <ECLSelect
               filter={true}
               options={users.activeUsers.map((u) => {
                  return {
                     id: u.id,
                     searchableString: u.username,
                     jsx: <ECLUserInfo user={u.id} />,
                     selected: false,
                  };
               })}
               setOptions={(selections) => {
                  //Get selection
                  const user = selections.filter((s) => s.selected)[0];
                  //Insert Text into text area
                  const textArea = document.querySelector(`#${props.editorId}`);
                  props.setInputText(
                     (prev) =>
                        prev.slice(0, textArea.selectionStart) +
                        `![](usr:{${user.id}})` +
                        prev.slice(textArea.selectionEnd),
                  );
               }}
               customTrigger={
                  <ECLThemeImage
                     alt={translate("User Picker")}
                     className="rt-icon"
                     fontAwesome="user"
                  />
               }
               menuWidth={275}
               containerId={props.editorId}
            />
         </div>
      </markdown-toolbar>
   );
}
